var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-button',{attrs:{"icon":"focus-zone"},on:{"click":_vm.clickHandler}},[(!_vm.justIcon)?_c('div',[_vm._v(" Найти на карте ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }